import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ClipboardEdit, UserCheck, Users } from 'lucide-react';
import { FC, useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useIsMobile } from '@/hooks/use-mobile';

interface Props {
  isOpen: boolean;
  setIsOpen: () => void;
  onSubmit: (payload: {
    officialValuation?: string;
    fairMarketValue?: string;
  }) => void;
}

const ValuationModal: FC<Props> = ({ isOpen, setIsOpen, onSubmit }) => {
  const [officialValuation, setOfficialValuation] = useState<string>('');
  const [fairMarketValue, setFairMarketValue] = useState<string>('');
  const isMobile = useIsMobile();

  const handleSubmit = () => {
    onSubmit({
      fairMarketValue,
      officialValuation,
    });

    setIsOpen();
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-[calc(100vw-32px)] md:max-w-lg">
        <>
          <DialogHeader>
            <DialogTitle className="text-center text-2xl font-bold text-tax-deepBlue mb-2">
              If you have an opinion of your property's fair market value enter
              that now. I not leave it blank and we'll estimate it.
            </DialogTitle>
          </DialogHeader>
          <div className="mt-4 bg-tax-lightGray rounded-lg p-4 border-l-4 border-tax-brightBlue">
            <div className="flex items-center mb-2">
              <ClipboardEdit className="h-5 w-5 mr-2 text-tax-brightBlue" />
              <h4 className="text-base font-bold text-tax-brightBlue">
                Your opinion of the fair market value of your property as of the
                assessment date:
              </h4>
            </div>
            <div className="flex items-center">
              <div className="relative flex-grow">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                  $
                </span>
                <Input
                  type="text"
                  placeholder="0"
                  value={fairMarketValue}
                  onChange={(e) => {
                    const raw = e.target.value.replace(/[^0-9]/g, ''); // keep only numbers
                    const formatted = raw.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    setFairMarketValue(formatted);
                  }}
                  className="pl-8 bg-white"
                />
              </div>
              {/* {fairMarketValue && (
                    <div className="ml-3 text-tax-deepBlue font-semibold">
                      {new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                        maximumFractionDigits: 0,
                      }).format(Number(fairMarketValue))}
                    </div>
                  )} */}
            </div>
          </div>
          <div className="flex flex-col gap-4 mt-6">
            <Button
              onClick={handleSubmit}
              className="bg-primary hover:bg-primary/90 text-primary-foreground text-lg font-medium flex items-center justify-center gap-3"
            >
              {/* <UserCheck className="w-5 h-5" /> */}
              Confirm
            </Button>
          </div>
        </>
      </DialogContent>
    </Dialog>
  );
};

export default ValuationModal;
